import { atom } from 'jotai'
import { showReleaseDialogAtom } from './modalAtom'
import { userAtom } from '@app/hooks/useUserProfile'
import { UserRole } from '@app/types'
import { openChangeClientAtom } from './layoutAtom'
import { selectedClientAtom } from './clientsAtom'
import { appLink } from '@app/config/appLink'
import { showLogoutDialogAtom } from './authAtom'

interface UserOption {
  id: string
  icon: string
  label: string
  to?: string
  onClick?: string
  requiresAuth?: boolean
  showInMenu?: boolean
  isAdmin?: boolean
  hidden?: boolean
  navigateTo?: string
}

// Toggle Atoms
const sidebarFooterLoadedAtom = atom(false)
const sidebarMenuLoadedAtom = atom(false)

const sidebarFullyLoadedAtom = atom((get) => {
  return get(sidebarFooterLoadedAtom) && get(sidebarMenuLoadedAtom)
})

// Action Atoms
const toggleReleaseDialogAtom = atom(null, (get, set) => {
  set(showReleaseDialogAtom, (prev) => !prev)
})

const openChangeClientActionAtom = atom(null, (_get, set) => {
  set(openChangeClientAtom, true)
})

const logoutActionAtom = atom(null, (_get, set) => {
  set(showLogoutDialogAtom, true)
})

// Dispather
const sidebarDispatchAtom = atom(null, (_get, set, action) => {
  if (action === 'toggleReleaseDialog') {
    set(toggleReleaseDialogAtom)
  } else if (action === 'openChangeClient') {
    set(openChangeClientActionAtom)
  } else if (action === 'logout') {
    set(logoutActionAtom)
  } else {
    throw new Error('unknown action')
  }
})

// Main Atoms
const visibleSidebarFooterAtom = atom<UserOption[]>((get) => {
  const { data: userProfile } = get(userAtom)
  const selectedClient = get(selectedClientAtom)
  const isAdmin = userProfile?.user_roles.includes(UserRole.ADMIN)

  const items: UserOption[] = [
    {
      id: 'notifications',
      icon: 'NotificationsIcon',
      label: 'Notifications',
      onClick: 'toggleReleaseDialog',
    },
    {
      id: 'changeClient',
      icon: 'People',
      label: selectedClient?.display_name || 'Select Client',
      onClick: 'openChangeClient',
    },
    {
      id: 'adminSettings',
      icon: 'Key',
      label: 'Admin Settings',
      navigateTo: appLink.manageUsers.path,
      isAdmin: true,
    },
    {
      id: 'logout',
      icon: 'SignOut',
      label: 'Logout',
      onClick: 'logout',
    },
  ]

  return items.filter((i) => (i.isAdmin ? isAdmin : true))
})

export {
  sidebarFooterLoadedAtom,
  visibleSidebarFooterAtom,
  sidebarDispatchAtom,
  sidebarMenuLoadedAtom,
  sidebarFullyLoadedAtom,
  type UserOption,
}
